import React from "react";
import "./PayEpayUtilityBillModal.scss";
import "./RunBotConfirmModal.scss";

const formatAmount = (amount, currency = "eur") =>
  `${Number(amount || 0).toFixed(2)} ${currency === "eur" ? "€" : currency.toUpperCase()}`;

const RunBotConfirmModal = ({ isOpen, bills = [], totalAmount, loading, onConfirm, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="pay-epay-modal-overlay" onClick={onClose}>
      <div className="pay-epay-modal-content run-bot-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="pay-epay-modal-title">FORCE BOT PAYMENT</h2>
        <p className="pay-epay-modal-description">
          The bot will try to pay the following {bills.length === 1 ? "bill" : `${bills.length} bills`} through Epay. This action cannot be reversed.
        </p>

        <div className="run-bot-bills">
          <div className="run-bot-bills-row header">
            <span>Date</span>
            <span>Client Number</span>
            <span>Provider</span>
            <span>User</span>
            <span className="amount">Amount</span>
          </div>
          {bills.map((bill) => {
            const date = bill.paymentDate || bill.createdAt;
            return (
              <div className="run-bot-bills-row" key={bill._id}>
                <span>{date ? new Date(date).toLocaleDateString("en-GB").replace(/\//g, ".") : "---"}</span>
                <span>{bill.clientNumber || "---"}</span>
                <span title={bill.utbProvider?.label}>{bill.utbProvider?.label || "---"}</span>
                <span title={bill.paidBy?.fullName}>{bill.paidBy?.fullName || "---"}</span>
                <span className="amount">{formatAmount(bill.price, bill.currency)}</span>
              </div>
            );
          })}
          <div className="run-bot-bills-row total">
            <span>Total</span>
            <span className="amount">{totalAmount}</span>
          </div>
        </div>

        <div className="pay-epay-modal-actions">
          <button className="pay-epay-confirm-btn" onClick={onConfirm} disabled={loading || !bills.length}>
            {loading ? "STARTING..." : "CONFIRM PAYMENT"}
          </button>
          <button className="pay-epay-cancel-btn" onClick={onClose} disabled={loading}>
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default RunBotConfirmModal;
